export enum DataCategory {
    IncomeMtr,
    OutcomeMtr,
    Technics,
    Storekeepers,
    OtherEmployers,
}
